module.exports = __webpack_public_path__ + "img/f8d8d3d.svg";